import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IExhibitorPotentialValuesPayloadState } from '@app-store/slices/companyStatistics/exhibitorPotentialValues'

interface TaskAction extends Action {
    payload: IExhibitorPotentialValuesPayloadState
}

const { onRequest, onSuccess, onFailure } = rootActions.companyStatistics.exhibitorPotentialValues

function* exhibitorexhibitorPotentialValuesSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/companies/stats/exhibitor/potential-values`)
        if (response.success) {
            yield put(onSuccess(response.result.data))
            yield payload?.sagaCB && payload.sagaCB?.onSuccess()
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        yield payload?.sagaCB && payload.sagaCB?.onError()
    }
}

function* exhibitorexhibitorPotentialValuesSaga(): any {
    yield takeLatest<TaskAction>(onRequest, exhibitorexhibitorPotentialValuesSagaTask)
}

export default exhibitorexhibitorPotentialValuesSaga
